export default __webpack_public_path__ + "static/bach-prelude-and-fugue-a-moll-e86971d633b28f35a80cbf3de72c5600.mp3";